import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "input_container" }
const _hoisted_5 = {
  key: 0,
  class: "password-error"
}
const _hoisted_6 = { class: "input_container" }
const _hoisted_7 = {
  key: 0,
  class: "password-error"
}
const _hoisted_8 = ["disabled"]

import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import SimpleLayout from "@/layouts/simple/SimpleLayout.vue";
import EmailPassword from "supertokens-web-js/recipe/emailpassword";
import logoImage from "@/assets/images/BeePallet_Logo_Black.png";
import { showErrorAlert, showSuccessAlert } from "@/helpers/SweetAlertHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const password = ref("");
const repeatPassword = ref("");
const showMatchError = ref(false);
const showPassError = ref(false);
const isSubmitting = ref(false);
const token = ref(route.query.token as string);

onMounted(() => {
  if (!token.value) {
    showErrorAlert("El enlace de recuperación es inválido o ha expirado.");
    router.push("/forgot-password");
  }
});

const handleResetPassword = async () => {
  showMatchError.value = false;
  showPassError.value = false;

  // Validate password length & structure
  const passwordRegex = /^(?=.*\d).{8,}$/;
  if (!passwordRegex.test(password.value)) {
    showPassError.value = true;
    return;
  }

  if (password.value !== repeatPassword.value) {
    showMatchError.value = true;
    return;
  }

  isSubmitting.value = true;

  try {
    const response = await EmailPassword.submitNewPassword({
      method: "token",
      formFields: [{ id: "password", value: password.value }],
      token: token.value,
    });

    if (response.status === "OK") {
      showSuccessAlert("", "Contraseña restablecida con éxito. Redirigiendo al login...");
      router.push({name: "login"});
    } else {
      showErrorAlert("El enlace ha expirado o es inválido.");
      router.push({name: "login"});
    }
  } catch (error) {
    showErrorAlert("Error al restablecer la contraseña.");
  } finally {
    isSubmitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(SimpleLayout, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "home" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(logoImage),
                class: "beepallet-logo",
                alt: "Logo de BeePallet"
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createElementVNode("form", {
            class: "login-form",
            onSubmit: _withModifiers(handleResetPassword, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("label", {
                class: "input_label",
                for: "password"
              }, "Contraseña", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "password",
                class: "input-field is-placeholder",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, password.value]
              ]),
              (showPassError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Debe contener al menos 8 caracteres e incluir un número."))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("label", {
                class: "input_label",
                for: "repeatPassword"
              }, "Repetir Contraseña", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                id: "repeatPassword",
                class: "input-field is-placeholder",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((repeatPassword).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, repeatPassword.value]
              ]),
              (showMatchError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Las contraseñas no coinciden."))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "btn-primary-green",
              disabled: isSubmitting.value
            }, " Restablecer contraseña ", 8, _hoisted_8)
          ], 32)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})